export const unknownEnumValueConverter = <T>(value: any) =>
  value === -1 || value === '' ? null : (value as T);
